import { EndpointDetailsController } from '../controller/EndpointDetailsController';
import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';

export class EndpointDetailsWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: EndpointDetailsController,
    });
  }

  set endpointId(endpointId: string) {
    this.setAttribute('data-endpoint-id', endpointId);
  }

  get endpointId(): string {
    const value = this.getAttribute('data-endpoint-id');
    return value ? value : '';
  }
}
